export default __webpack_public_path__ + "static/media/filterArrow.0a101a49.svg";